import React, { FunctionComponent, useMemo } from 'react';
import CallsSourceGraphContainer from './calls-source-graph-container';
import { endOfYear, startOfYear } from 'date-fns';
import { useCallSourcesData } from '../../../hooks/use-call-source-data/use-call-source-data';

export interface CallSourceChartData {
  month: string;
  [key: string]: string | number; // Toutes les sources sont dynamiques
}

type CallsSourceGraphRepositoryProps = {
  bilikZoneIds?: number[];
  proViewIds?: number[];
  year?: number;
  filters?: any[];
  unique?: boolean;
};

const now = new Date();

const CallsSourceGraphRepository: FunctionComponent<
  CallsSourceGraphRepositoryProps
> = ({
  bilikZoneIds,
  proViewIds,
  unique,
  year = now.getFullYear(),
  filters,
}) => {
  const dateRange = useMemo(() => {
    const date = new Date();
    date.setFullYear(year);
    return {
      after: startOfYear(date),
      before: endOfYear(date),
    };
  }, [year]);

  const { loading, error, monthlyData, availableSources } = useCallSourcesData({
    after: dateRange.after,
    before: dateRange.before,
    bilikZoneIds,
    proViewIds,
    additionalFilters: filters || [],
    unique,
    mode: 'monthly',
  });

  const chartData: CallSourceChartData[] = useMemo(() => {
    if (loading || error || !monthlyData) {
      return [];
    }

    return monthlyData.map((item) => {
      const chartItem: CallSourceChartData = {
        month: String(item.month),
      };

      availableSources.forEach((source) => {
        chartItem[source] = Number(item[source] || 0);
      });

      return chartItem;
    });
  }, [loading, error, monthlyData, availableSources]);

  return (
    <CallsSourceGraphContainer
      chartData={chartData}
      availableSources={availableSources}
      loading={loading}
      error={error}
    />
  );
};

export default CallsSourceGraphRepository;
